var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { FlatList, View } from 'react-native';
import { Divider } from '../Divider';
import { useStyleSheet } from '../../hooks';
import { createStyleSheet } from '../../utils';
import { Month, Weekdays } from './components';
import { useCalendarData, useCalendarMonthHeight } from './hooks';
import { useCalendarContext } from './contexts';
export const Calendar = ({ style, appointments, selected, onSelect, disabledBefore, disabledAfter }) => {
    const _a = useCalendarData(), { calendarRef } = _a, flatListConfig = __rest(_a, ["calendarRef"]);
    const { active } = useCalendarContext();
    const calendarHeight = useCalendarMonthHeight({ date: active });
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: [styles.container, style] },
        React.createElement(Weekdays, null),
        React.createElement(Divider, { style: styles.divider, type: 'horizontal' }),
        React.createElement(FlatList, Object.assign({ ref: calendarRef, keyExtractor: (item) => item, style: styles.list, renderItem: ({ item }) => (React.createElement(Month, { appointments: appointments, date: item, onSelect: onSelect, selected: selected, disabledBefore: disabledBefore, disabledAfter: disabledAfter })), disableIntervalMomentum: true, showsVerticalScrollIndicator: false, snapToAlignment: 'center', decelerationRate: 'fast', windowSize: 7, initialNumToRender: 3, snapToInterval: calendarHeight, viewabilityConfig: {
                viewAreaCoveragePercentThreshold: 90
            } }, flatListConfig))));
};
const getStyles = createStyleSheet(({ size }) => ({
    container: {},
    list: {
        flexBasis: 5 * (size.M + size.B + 6 + size.C) + 2 * size.C,
        flexGrow: 0,
        width: '100%'
    },
    divider: {}
}));
Calendar.displayName = 'Calendar';
export * from './contexts';
export { Month, Weekdays } from './components';
export { useCalendarMonthHeight } from './hooks';
//# sourceMappingURL=index.js.map